export default __webpack_public_path__ + "static/media/CloudLibrary.98e8cf7a.svg";